export default function Divider (pButton)
{
  this.preInitInsertDividerButton = () =>
  {
    const baseId = pButton.pAttribute.id + '_Dialog';

    pButton.pAttribute.Dialog = BEditor.obj.create(BEditor.UI.EditDividerDialog, [{ id: baseId, waDialogParameters: pButton.pAttribute.parameters }, { parentComponent: pButton.pThis }]);
    BEditor.Dialogs['Divider'] = { 'id': pButton.pAttribute.id + '_Dialog', 'codeEditor': pButton.pAttribute.codeEditor, 'dialog': pButton.pAttribute.Dialog};
  };
}